riot.tag2('page-index-exhibition-half', '<dl class="exhibitors col m6"><virtual each="{entry in opts.exhibitors}"><dt id="{&#39;exhibitor-&#39; + entry.number}">{entry.name}</dt><dd><a href="{entry.url}" if="{entry.url}">{entry.url}</a></dd></virtual></dl>', 'dl.exhibitors{margin-left:30px;margin-top:0;margin-bottom:0}', '', function(opts) {
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/page-index-exhibition-half.tag.slim
// module id = 37
// module chunks = 0